import { combineSlices } from '@reduxjs/toolkit';
import supportMessageReducer from './supportMessage/supportMessageReducer';
import optionReducer from './option/optionModalReducer';

const modalReducer = combineSlices({
    supportMessage: supportMessageReducer,
    option: optionReducer
});

export default modalReducer;
